// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__SMoYH","range":"MonthRangeSwitch_range__2C8C9","disabled":"MonthRangeSwitch_disabled__1HlmN"};